import Login from "pages/Authentication/Login/Login";
import Logout from "pages/Authentication/Logout";
import Color from "pages/Color";
import ForbidentView from "pages/ForbidentView/ForbidentView";
import SideBarPage from "pages/SideBar";
import Typography from "pages/Typography";
import { Redirect } from "react-router";
import { AppLoggingApiMaster } from "views/AppLoggingApiView/AppLoggingApiView";
import AppUserGroupingView from "views/AppUserGroupingView/AppUserGroupingView";
import AppUserGroupingProjectProfileView from "views/AppUserGroupingProjectProfileView/AppUserGroupingProjectProfileView";
import AppUserView from "views/AppUserView/AppUserView";
import EmailRemindConfigView from "views/EmailRemindConfigView/EmailRemindConfigView";
import InitView from "views/InitView/InitView";
import IntegrationEapConfigurationView from "views/IntegrationEapConfigurationView/IntegrationEapConfigurationView";
import LDAPConfigurationView from "views/LDAPConfiguration/LDAPConfigurationView";
import LoginConfigurationView from "views/LoginConfigurationView/LoginConfigurationView";
import MenuReportView from "views/MenuReportView/MenuReportView";
import NotificationView from "views/NotificationView/NotificationView";
import OrganizationTreeView from "views/OrganizationTreeView/OrganizationTreeView";
import PositionView from "views/PositionView/PositionView";
import ProjectAuthorizationReportView from "views/ProjectAuthorizationReport/ProjectAuthorizationReportView";
import ResponsibilityView from "views/ResponsibilityView/ResponsibilityView";
import RoleView from "views/RoleView/RoleView";
import SiteView from "views/SiteView/SiteView";
import UserManualView from "views/UserManualView/UserManualMasterView";
import DocumentPermissionView from "views/DocumentPermissionView/DocumentPermissionView";
import WorkflowDefinitionView from "views/WorkflowDefinitionView/WorkflowDefinitionView";
import WorkflowDirectionView from "views/WorkflowDirectionView/WorkflowDirectionView";
import WorkflowParameterView from "views/WorkflowParameterView/WorkflowParameterView";
import WorkflowStepView from "views/WorkflowStepView/WorkflowStepView";
import {
  APP_LOGGING_API_ROUTE,
  APP_USER_GROUPING_ROUTE,
  APP_USER_GROUPING_PROJECT_PROFILE_ROUTE,
  APP_USER_MASTER_ROUTE,
  APP_USER_ROUTE,
  COLOR_PAGE_ROUTE,
  EMAIL_REMINDER_CONFIG_ROUTE,
  INIT_ROUTE,
  INTEGRATION_EAP_CONFIGURATION_ROUTE,
  LDAP_CONFIGURATION_ROUTE,
  LOGIN_CONFIGURATION_ROUTE,
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  MENU_REPORT_ROUTE,
  ORGANIZATION_ROUTE,
  DOCUMENT_PERMISSION_ROUTE,
  POSITION_ROUTE,
  PROJECT_AUTHORIZATION_REPORT_ROUTE,
  RESPONSIBILITY_ROUTE,
  ROLE_ROUTE,
  SIDE_BAR_PAGE_ROUTE,
  SITE_ROUTE,
  TYPOGRAPHY_PAGE_ROUTE,
  USER_MANUAL_ROUTE,
  USER_NOTIFICATION_ROUTE,
  WORKFLOW_DEFINITION_ROUTE,
  WORKFLOW_DIRECTION_ROUTE,
  WORKFLOW_PARAMETER_ROUTE,
  WORKFLOW_STEP_ROUTE,
} from "./route-consts";

export interface Route {
  path: string;
  component: () => JSX.Element;
  exact?: boolean;
}

const userRoutes: Route[] = [
  // Default init route for template:

  {
    path: TYPOGRAPHY_PAGE_ROUTE,
    component: Typography,
  },
  {
    path: COLOR_PAGE_ROUTE,
    component: Color,
  },
  {
    path: SIDE_BAR_PAGE_ROUTE,
    component: SideBarPage,
  },
  {
    path: APP_USER_ROUTE,
    component: AppUserView,
  },
  {
    path: APP_USER_GROUPING_ROUTE,
    component: AppUserGroupingView,
  },
  {
    path: APP_USER_GROUPING_PROJECT_PROFILE_ROUTE,
    component: AppUserGroupingProjectProfileView,
  },
  {
    path: ROLE_ROUTE,
    component: RoleView,
  },
  {
    path: DOCUMENT_PERMISSION_ROUTE,
    component: DocumentPermissionView,
  },
  {
    path: APP_LOGGING_API_ROUTE,
    component: AppLoggingApiMaster,
  },
  {
    path: RESPONSIBILITY_ROUTE,
    component: ResponsibilityView,
  },
  { path: ORGANIZATION_ROUTE, component: OrganizationTreeView },

  // Created route for project:

  {
    path: WORKFLOW_DEFINITION_ROUTE,
    component: WorkflowDefinitionView,
  },
  {
    path: WORKFLOW_DIRECTION_ROUTE,
    component: WorkflowDirectionView,
  },

  {
    path: WORKFLOW_STEP_ROUTE,
    component: WorkflowStepView,
  },
  {
    path: WORKFLOW_PARAMETER_ROUTE,
    component: WorkflowParameterView,
  },

  {
    path: SITE_ROUTE,
    component: SiteView,
  },

  {
    path: USER_MANUAL_ROUTE,
    component: UserManualView,
  },

  {
    path: INIT_ROUTE,
    component: InitView,
  },

  // {
  //   path: NATION_ROUTE,
  //   component: NationView,
  // },

  // {
  //   path: PROVINCE_ROUTE,
  //   component: ProvinceView,
  // },

  // {
  //   path: DISTRICT_ROUTE,
  //   component: DistrictView,
  // },

  // {
  //   path: WARD_ROUTE,
  //   component: WardView,
  // },
  {
    path: LOGIN_CONFIGURATION_ROUTE,
    component: LoginConfigurationView,
  },
  {
    path: USER_NOTIFICATION_ROUTE,
    component: NotificationView,
  },
  {
    path: LDAP_CONFIGURATION_ROUTE,
    component: LDAPConfigurationView,
  },
  // {
  //   path: REGION_ROUTE,
  //   component: RegionView,
  // },
  {
    path: POSITION_ROUTE,
    component: PositionView,
  },
  {
    path: MENU_REPORT_ROUTE,
    component: MenuReportView,
  },
  {
    path: EMAIL_REMINDER_CONFIG_ROUTE,
    component: EmailRemindConfigView,
  },
  {
    path: INTEGRATION_EAP_CONFIGURATION_ROUTE,
    component: IntegrationEapConfigurationView,
  },
  {
    path: PROJECT_AUTHORIZATION_REPORT_ROUTE,
    component: ProjectAuthorizationReportView,
  },
  // this base route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: () => <Redirect to={APP_USER_MASTER_ROUTE} />,
  },
];

const authRoutes = [
  { path: LOGOUT_ROUTE, component: Logout },
  { path: LOGIN_ROUTE, component: Login },
  {
    path: "/403",
    // exact: true,
    component: ForbidentView,
  },
];

export { authRoutes, userRoutes };
